import { useMutation, useQuery } from "@tanstack/react-query";
import {
  AuthSignup,
  getBusinessDetails,
  GooglePlaceDetails,
  signup,
  validateEmail,
  verifyTurnstileToken,
} from "./authApi";

export function useVerifyTurnstileTokenQuery() {
  return useMutation({
    mutationFn: ({ turnstileToken }: { turnstileToken: string }) =>
      verifyTurnstileToken(turnstileToken),
  });
}

export function useGetBusinessDetailsQuery(googlePlaceId: string) {
  return useQuery<GooglePlaceDetails>({
    queryKey: ["get-business-details", googlePlaceId],
    queryFn: () => getBusinessDetails(googlePlaceId),
  });
}

export function useValidateEmailQuery() {
  return useMutation({
    mutationFn: ({ email }: { email: string }) => validateEmail(email),
  });
}

export function useSignupQuery() {
  return useMutation({
    mutationFn: (signupData: AuthSignup) => signup(signupData),
  });
}
